import { useRef, useState } from "react";

const CustomFileReader = ({ handleLinks }) => {
    const [hoverCSV, setHoverCSV] = useState(false);
    const [fileName, setFileName] = useState('');
    const fileInputRef = useRef(null);

    const parseCSV = (text) => {
        const rows = text
            .trim()
            .split('\n')
            .map((row) => row.split(','));

        const processedElements = rows.flatMap(innerArray => (innerArray.filter(text => text.includes("https://copilot"))));

        handleLinks(processedElements);
    };

    const handleFileChange = (file) => {
        const reader = new FileReader();

        reader.onload = (event) => {
            const text = event.target?.result;
            parseCSV(text);
            setFileName?.(file.name);
        };
        reader.readAsText(file);
    };

    return (
        <div
            onDrop={(event) => {
                event.preventDefault();
                handleFileChange(event.dataTransfer.files[0])
            }}
            onDragOver={(event) => {
                event.preventDefault();
                setHoverCSV(true);
            }}
            className={`${hoverCSV && "csvReaderContainerBackGround"} ${"csvReaderContainer"} `}
            onDragLeave={() => setHoverCSV(!hoverCSV)}
        >
            <span>{fileName ? fileName : "Drag and drop your CSV file here, or upload it from your computer."}</span>
            <label onClick={() => fileInputRef.current?.click()} htmlFor="inputFile">
                Upload File
            </label>
            <input type="file" accept=".csv" ref={fileInputRef} onChange={(event) => handleFileChange(event.target.files[0])} />
        </div>
    )
}

export default CustomFileReader;